import type { SmartLinkDestination } from "../types/smartLink";

export const getSmartLinkDestination = (
  userAgent: string,
  androidStoreUrl: string,
  iosStoreUrl: string,
  isTouchMac = false,
): SmartLinkDestination => {
  const androidUrl = androidStoreUrl.trim();
  const appleUrl = iosStoreUrl.trim();
  const isAndroid = /android/i.test(userAgent);
  const isIos = /iPad|iPhone|iPod/i.test(userAgent) || isTouchMac;

  if (isAndroid && androidUrl) {
    return { platform: "android", url: androidUrl };
  }

  if (isIos && appleUrl) {
    return { platform: "ios", url: appleUrl };
  }

  // If the app is only available in one store, every device still has a useful
  // destination. Desktop and unknown devices get a choice when both exist.
  if (androidUrl && !appleUrl) {
    return { platform: "android", url: androidUrl };
  }

  if (appleUrl && !androidUrl) {
    return { platform: "ios", url: appleUrl };
  }

  return { platform: "desktop", url: null };
};

export const isSupportedStoreUrl = (value: string): boolean => {
  try {
    const url = new URL(value);
    return (
      url.protocol === "https:" &&
      (url.hostname === "play.google.com" || url.hostname === "apps.apple.com")
    );
  } catch {
    return false;
  }
};
